export function basicTask() {
	const backTop = document.querySelector(".back-to-top");
	const counterItem = document.querySelectorAll(".counter");
	const setBackground = document.querySelectorAll("[setBackground]");
	const menuToggle = document.querySelector(".site-menu-toggle");
	const closeMenu = document.querySelector(".close-menu");
	const searchToggle = document.querySelector(".search-toggle");
	const searchWrap = document.querySelector(".searchbox");

	const bodyWrap = document.querySelector("body");
	const menuMobile = document.querySelector(".mobile-nav-wrap");
	const hamburger = document.querySelector(".hamburger");
	const breadcrumb = document.querySelector(".global-breadcrumb");
	const breadcrumb_wrap = document.querySelector(".global-breadcrumb .container");


	try {
		const homeBussiness = $(".home-business");
		const bgContainer = $(".home-business .bg-placeholder");
		$(".home-business .item-bg").each(function () {
			$(this).on("mouseenter", function () {
				let srcImage = $(this).attr("data-src");
				bgContainer[0].style.setProperty("--bg-hover", `url(${srcImage})`);
				bgContainer.css("--bg-hover", `url(${srcImage})`);
			});
		});

		homeBussiness.on("mouseenter", function () {
			$(this).addClass("is-hover");
		});
		bgContainer.on("mouseenter", function () {
			$(this).addClass("active");
		});
		bgContainer.on("mouseleave", function () {
			$(this).removeClass("active");
		});
	} catch (error) {

	}
	// Card Flex  Hover , click
	const cardHover = $('.card-option');
	const cardClick = $('.card-click');

	cardHover.on('mouseenter', function () {
		$('.card-option').removeClass('active');
		$(this).toggleClass('active');
	});
	cardClick.on('mouseenter', function () {
		$('.card-click').removeClass('active');
		$(this).toggleClass('active');
	});



	$(".filter-table-wrap").each(function () {
		let x = 5;
		$(this).find("tbody tr").slice(0, 5).show();
		let size = $(this).find("tbody tr").length;
		console.log(size);
		if (size < x || size == x) {
			$(this).find(".ajax-btn-wrap").addClass("disble-btn");
		}
		$(".filter-table-wrap")
			.find(".ajax-btn-wrap .btn-load-more")
			.on("click", function (e) {
				e.preventDefault();
				x = x + 5;
				$(this)
					.parents(".filter-table-wrap")
					.find("tbody tr")
					.slice(0, x)
					.slideDown();
				if (x >= size || size < x) {
					$(this).parent().addClass("disble-btn");
				}
			});
	});

	if ($(window).width() > 1024.1) {

		// Breadcrumb 
		if ($('.banner-breadcrumb').length) {
			// Ensure breadcrumb is defined
			if (breadcrumb !== null) {
				let anchorElements = breadcrumb.querySelectorAll(":scope li");
				let secondAnchor = anchorElements[1];
				let thirddAnchor = anchorElements[2];
				// Prevent duplicates
				if (!breadcrumb.querySelector("h2")) {
					let title;
					if (anchorElements.length > 1 && anchorElements.length < 3) {
						title = secondAnchor.innerText || "";
					} else if (anchorElements.length > 2) {
						title = thirddAnchor.innerText || "";
					} else {
						return;
					}
					let newNode = document.createElement("h2");
					newNode.textContent = title;
					breadcrumb_wrap.appendChild(newNode);
				}
			} else {
			}
		}
	}

	if ($(".news-detail .social").length) {
		$(".news-detail .social").scrollToFixed({
			zIndex: 99,
			marginTop: 100,
			limit: function limit() {
				return (
					$("footer").offset().top -
					$("header").outerHeight() -
					100
				);
			},
			postUnfixed: function () {
				$(this).addClass("reached-limit");
			},
			preFixed: function () {
				$(this).removeClass("reached-limit");
			}
		});
	}

	//Basic Toggle Function
	menuToggle.addEventListener("click", (e) => {
		e.preventDefault();
		menuMobile.classList.toggle("is-open");
		hamburger.classList.toggle("is-active");
		bodyWrap.classList.toggle("overlay-bg");
	});
	closeMenu.addEventListener("click", () => {
		menuMobile.classList.remove("is-open");
		hamburger.classList.remove("is-active");
		bodyWrap.classList.remove("overlay-bg");
	});

	// Search Toggle
	searchToggle.addEventListener("click", () => {
		if (searchWrap !== null) {
			searchWrap.classList.toggle("is-open");
			bodyWrap.classList.toggle("overlay-bg");
		}

	});

	//back to top
	try {
		if (backTop !== null) {
			backTop.addEventListener("click", (event) => {
				event.preventDefault();
				$("html, body").animate({ scrollTop: 0 }, "300");
			});
		}
	} catch (error) {

	}

	$(".menu-item > a").wrap("<div class='title'></div>");
	$(".menu-item-has-children >.title").append("<div class='icon'></div>");
	//Tab function

	$(".mobile-menu-nav .menu-item-has-children .title .icon").on("click", function () {
		$(this).parent().next().slideToggle();
		$(this).parent().toggleClass('is-active');
	});

	$('.mobile-primary-menu .drop-down .title .icon').on('click', function () {
		$(this).parent().toggleClass('is-open');
		$(this).parent().next().slideToggle();
	})

	//Tab function
	$(".rolling-text").each(function () {
		const $element = $(this);
		const innerText = $element.text().trim();
		$element.empty();

		const createTextContainer = () =>
			$("<div>")
				.addClass("block")
				.append(
					[...innerText].map((letter) =>
						$("<span>")
							.addClass("letter")
							.text(letter.trim() === "" ? "\xa0" : letter)
					)
				);

		$element.append(createTextContainer()).append(createTextContainer());
	});
	$(".toggle-wrap").each(function (index, element) {
		let $this = $(this);
		$this.addClass("toggle-instance-" + index);
		$(".toggle-instance-" + index + " .toggle-item").click(function () {
			if ($(this).hasClass("is-toggle")) {

				$(this).find(".article").slideUp();
				$(this).removeClass("is-toggle");
			} else {
				$(".toggle-item").find(".article").slideUp();
				$(".toggle-item").removeClass("is-toggle");
				$(this).find(".article").slideDown();
				$(this).addClass("is-toggle");
			}
		});
	});

	$(".table-view-more").each(function () {
		// Initially show only first 10 rows
		$(this).find("tbody tr").slice(0, 10).show();

		// Hide button if there are 10 or fewer rows
		let size = $(this).find("tbody tr").length;
		if (size <= 10) {
			$(this).find(".ajax-btn-wrap").addClass("disble-btn");
		}

		// Click handler to show all rows and hide button
		$(this).find(".ajax-btn-wrap .btn-primary").on("click", function (e) {
			e.preventDefault();

			// Show all remaining rows
			$(this).parents(".table-view-more").find("tbody tr").slideDown();

			// Hide the button
			$(this).parent().addClass("disble-btn");
		});
	});
	if ($(".sticky-nav").length) {
		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: 100,
			limit: function () {
				return (
					$("footer").offset().top -
					$(".sticky-nav").outerHeight() -
					$("header").outerHeight()
				);
			},
			fixed: function () {
				// sticky element is active
				$(this).addClass("is-sticky").removeClass("at-limit");
			},
			postLimit: function () {
				// reached the limit
				$(this).addClass("at-limit").removeClass("is-sticky");
			},
			postFixed: function () {
				// no longer fixed (scrolling back up)
				$(this).removeClass("is-sticky at-limit");
			}
		});
	}
	$(window).scroll(function () {
		var scrollDistance = $(window).scrollTop();

		$(".swiper-sticky-nav").each(function (navIndex, navElement) {

			var $nav = $(navElement);
			var targetSelector = $nav.data("target-sections") || ".scroll-section-wrap";
			var $sections = $(targetSelector).find(".anchor-section-id");

			// Check each section's position
			$sections.each(function (i) {
				if (
					$(this).position().top -
					$(".sticky-nav").outerHeight() -
					$("header").outerHeight() -
					1 <= scrollDistance
				) {
					// Remove active class from all items in this specific nav
					$nav.find(".swiper-slide .item.is-active").removeClass("is-active");
					// Add active class to the corresponding item in this specific nav
					$nav.find(".swiper-slide .item").eq(i).addClass("is-active");
				}
			});
		});
	}).scroll();
	$(".sticky-nav .item a").on("click", function (event) {
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - offset,
				},
				800,
				function () {
					// window.location.hash = hash;
				}
			);
		} // End if
	});


	//Tab function
	$(".tab-nav a").on("click", function () {
		$(this).parents(".tab-nav").find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		var tab = $(this).attr("data-type");
		$(this).parents("section").find(".tab-item").removeClass("active");
		$(this)
			.parents("section")
			.find("#" + tab)
			.addClass("active");
	});
	//Tab hover


	$(".load-more-item-wrap").each(function () {
		const $wrap = $(this);
		const increment = parseInt($wrap.attr("item-amount"));
		const $cols = $wrap.find(".item");
		const $btn = $wrap.find(".btn-load-more");
		const $ajaxWrap = $wrap.find(".ajax-center-wrap");
		const total = $cols.length;
		$cols.slice(0, increment).css({ display: "flex" });
		if (total <= increment) {
			$ajaxWrap.addClass("disble-btn");
			return;
		}
		let visibleCount = increment;
		$btn.on("click", function (e) {
			e.preventDefault();
			visibleCount += increment;

			$cols.slice(0, visibleCount).slideDown().css({ display: "flex" });

			if (visibleCount >= total) {
				$ajaxWrap.addClass("disble-btn");
			}
		});
	});



	//setBackground
	setBackground.forEach((attributes) => {
		attributes.style.cssText = `
		background-image: url(${attributes.getAttribute("setBackground")});
		background-size: cover;
		background-position: center;
	  `;
	});
	try {
		document.querySelectorAll('.wrap-form textarea').forEach(function (textarea) {
			textarea.value = textarea.value.trim();
		});
	} catch (error) {

	}

	if (counterItem !== null) {
		if (counterItem.length) {
			const counterUp = window.counterUp.default;
			const callback = (entries) => {
				entries.forEach((entry) => {
					const el = entry.target;
					if (
						entry.isIntersecting &&
						!el.classList.contains("is-visible")
					) {
						counterUp(el, {
							duration: 3000,
							delay: 200,
						});
						el.classList.add("is-visible");
					}
				});
			};
			const IO = new IntersectionObserver(callback, { threshold: 1 });

			counterItem.forEach((counter) => {
				IO.observe(counter);
			});
		}
	}
}

export function isSvgFile(src) {
	// Check if the source URL ends with .svg
	return src.toLowerCase().endsWith(".svg")
}



export function convertImgToSvg(imgElement) {
	// Get the src attribute of the img element
	const imgSrc =
		imgElement.getAttribute("src") || imgElement.getAttribute("data-src")
	if (!isSvgFile(imgSrc)) {
		// Alert
		console.error("Not an SVG file:", imgSrc)

		const notSvgImg = document.createElement("img")
		notSvgImg.className = "img-generate"
		notSvgImg.style.opacity = 1
		notSvgImg.src = imgSrc
		// Replace the original image element with the new one
		imgElement.parentNode.replaceChild(notSvgImg, imgElement)
		return
	}

	function setStrokeDashArrayInline(svgContent) {
		// Create a new DOM element to parse the SVG content
		const tempDiv = document.createElement("div")
		tempDiv.innerHTML = svgContent

		// Find all vector path elements in the SVG
		const vectorPaths = tempDiv.querySelectorAll("path")

		// Iterate through vector paths and calculate the stroke-dasharray
		vectorPaths.forEach((path) => {
			const isContainStrokeDasharray =
				path.getAttribute("stroke-dasharray")
			const pathLength = path.getTotalLength()
			path.style.setProperty("--data-stroke-dasharray", pathLength)
			if (isContainStrokeDasharray) return
			path.setAttribute("stroke-dasharray", pathLength)
			// console.log(pathLength);
		})

		// Return the modified SVG content
		return tempDiv.innerHTML
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// Fetching Image SVG

				fetch(imgSrc)
					.then((response) => response.text())
					.then((svgContent) => {
						const modifiedSvgContent =
							setStrokeDashArrayInline(svgContent)
						// Create a temporary div element to parse the SVG content
						const tempDiv = document.createElement("div")
						const isError = svgContent.includes(
							"<title>Error</title>"
						)
						tempDiv.className = "svg-generate"
						if (isError)
							tempDiv.innerHTML =
								"<span class='image-not-found'>Image has been removed or moved.</span>"
						else tempDiv.innerHTML = modifiedSvgContent
						// else tempDiv.innerHTML = svgContent;

						tempDiv.setAttribute("data-src", imgSrc)
						// Replace the img element with the new svg element
						imgElement.parentNode.replaceChild(tempDiv, imgElement)

						const svgLoadedEvent = new CustomEvent("svg-loaded", {
							detail: {
								element: tempDiv,
								source: imgSrc,
								content: modifiedSvgContent,
								svgContent: svgContent,
								isError: isError,
								imgElement,
							},
						})
						document.body.dispatchEvent(svgLoadedEvent)

						// Stop observing the element after it's loaded
						observer.unobserve(imgElement)
					})
					.catch((error) => {
						console.error(
							"Error fetching or replacing image:",
							error
						)
					})
			}
		})
	})
	// Start observing the image element
	observer.observe(imgElement)
}

export function generateSVG(selector = ".image-svg") {
	const imageContainers = document.querySelectorAll(selector)
	imageContainers.forEach((imageContainer) => {
		// Find the img element within each container
		const images = imageContainer.querySelectorAll("img")
		images.forEach((img) => {
			convertImgToSvg(img)
		})
	})
	console.log('test svg');
}